import React from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
import "../Dashboard/Dashboard.css";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import salePic from "../../assets/sale.svg";
import DatePic from "../../assets/date.svg";
import Savings from "../../assets/savings.svg";
import RecentActivities from "../../Components/RecentActivities/RecentActivities";
import TopVouchers from "../TopVouchers/TopVouchers";
import VoucherSummary from "../VoucherSummary/VoucherSummary";
import { useState } from "react";
import { useEffect } from "react";
import { userId } from "../../Utils/LocalStorage";
import { VoucherDashBoardAPI } from "../../Utils/Api/VouchersDashBoardAPI";
import Loader from "../../Components/Loader/Loader";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import ManageVouchersVoucherDashboard from "../ManageVouchers/ManageVouchersVoucherDashboard";
import { Graph } from "./Graph";
import { toast } from "react-toastify";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { useNavigate } from "react-router-dom";

const VouchersDashboard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [GraphData, setGraphData] = useState([]);
  const [GraphData1, setGraphData1] = useState([]);

  const Bu_id = userId();

  const navigate = useNavigate();

  const VouchersDashboardAPiHandler = async () => {
    const val = {
      business_id: Bu_id,
      start_date: "",
      end_date: "",
    };
    setLoading(true);
    const VouchersDashboardData = await VoucherDashBoardAPI(val, () => {
      navigate("/");
    });

    if (VouchersDashboardData === false) {
      toast.error(ServerError, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (VouchersDashboardData.success === true) {
        setData(VouchersDashboardData?.data ? VouchersDashboardData?.data : []);
        setGraphData(
          VouchersDashboardData?.data.sales_by_date
            ? VouchersDashboardData?.data.sales_by_date
            : ""
        );
        setGraphData1(
          VouchersDashboardData?.data.sales_by_volume
            ? VouchersDashboardData?.data.sales_by_volume
            : ""
        );
        setLoading(false);
      } else if (VouchersDashboardData.status == 429) {
        setLoading(true);
        toast.error(VouchersDashboardData.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        setData([]);
        setGraphData("");
        setGraphData1("");
      }
    }
  };

  useEffect(() => {
    VouchersDashboardAPiHandler();
  }, []);
  return (
    <>
      {loading ? <Loader /> : ""}
      <Row className="dashboard-card mt-4 pt-2">
        <Col md="4">
          <div className="card green-card">
            <div className="dash-img-main mt-1">
              <div className="dash-img">
                <Image loading="lazy" src={Savings} height="20px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Life time sales</p>
              <p className="dash-text2">
                ${data?.life_time_sales == "" ? 0 : data?.life_time_sales}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
        <Col md="4">
          <div className="card green-card">
            <div className="dash-img-main mt-1">
              <div className="dash-img">
                <Image loading="lazy" src={salePic} height="22px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">Year to date Sales</p>
              <p className="dash-text2">
                ${data.year_todate_sales == "" ? 0 : data.year_todate_sales}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
        <Col md="4">
          <div className="card green-card">
            <div className="dash-img-main mt-1">
              <div className="dash-img">
                <Image loading="lazy" src={DatePic} height="22px"></Image>
              </div>
            </div>
            <div className="dash-content">
              <p className="dash-text1 pt-4">this month Sales</p>
              <p className="dash-text2">
                ${data.this_month_sales == "" ? 0 : data.this_month_sales}
              </p>
              <p className="text-right pb-4"></p>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="mt-4 VouchersDashboard">
        <Col md="8">
          {/* <TopVouchers topVouchers={data ? data.top_voucher_listing : ""} /> */}
          <ManageVouchersVoucherDashboard />
        </Col>

        <Graph
          GraphData={GraphData}
          GraphData1={GraphData1}
          setGraphData1={setGraphData1}
          setGraphData={setGraphData}
          setLoading={setLoading}
          Bu_id={Bu_id}
        />

        <Col md="4">
          <VoucherSummary
            summaryActiveVoucher={data ? data.summary_active_voucher : ""}
            summaryPurchasedVoucher={data ? data.summary_purchased_voucher : ""}
            summaryRedeemedVoucher={data ? data.summary_redeemed_voucher : ""}
          />
        </Col>
      </Row>
    </>
  );
};

export default VouchersDashboard;
